import * as yup from 'yup';

const affiliateAgentSchema = yup.object({
  name: yup
    .string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters long'),
  
    email: yup
    .string()
    .required('Email is required')
    .email('Invalid email format'),

  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long'),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/, 'Password must contain at least one uppercase letter, one lowercase letter, and one number'),

    mobileNumber: yup
    .string()
    .required('Mobile number is required'),
    // .matches(/^\+?([0-9]{1,3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4,6})$/, 'Invalid phone number format'),

    emiratesId: yup.string()
    .matches(/^\d+$/, 'Emirates Id must be a number')
    .length(15, 'Emirates Id must be exactly 15 number long')
    .required('Emirates Id is required')
});

export default affiliateAgentSchema;